import { selectedStoreKey } from '@/config';
import { corverProject } from '@/config/nav';
import { useIamAuthStore } from '@/store/iam';
import { warning } from '@/utils/iam';
import { useNavStore } from '@/store/breadcrumb';
import {
  createRouter,
  createWebHashHistory,
  Router,
  RouteRecordRaw,
} from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: {
      name: 'Login',
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/auth/login.vue'),
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/auth/register/index.vue'),
  },
  {
    path: '/register-tip',
    name: 'RegisterTip',
    component: () => import('../views/auth/register-tip.vue'),
  },
  {
    path: '/retrieve-password',
    name: 'RetrievePassword',
    component: () => import('@/views/auth/retrieve-password.vue'),
  },
  {
    path: '/retrieve-password-tip',
    name: 'RetrievePasswordTip',
    component: () => import('@/views/auth/retrieve-password-tip.vue'),
  },
  {
    path: '/portal',
    name: 'portal',
    component: () => import('../views/Portal.vue'),
    children: [
      {
        // 当 /user/:id/posts 匹配成功
        // UserPosts 将被渲染到 User 的 <router-view> 内部
        path: 'home',
        name: 'home',
        component: () => import('../views/home/home.vue'),
        meta: {
          title: '首页',
          root: true,
          nav: [],
        },
      },
      {
        // 当 /user/:id/posts 匹配成功
        // UserPosts 将被渲染到 User 的 <router-view> 内部
        path: ':app+',
        name: 'micro',
        component: () => import('../views/micro/micro.vue'),
      },
    ],
  },
  {
    path: '/setting',
    name: 'Setting',
    component: () => import('@/views/setting.vue'),
    children: [
      {
        path: 'info',
        name: 'Info',
        component: () => import('@/views/account/info.vue'),
      },
      {
        path: 'set-password',
        name: 'SetPassword',
        component: () => import('@/views/account/set-password.vue'),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
// https://github.com/umijs/qiankun/issues/1361

// GOOD
const nav = ['home', 'micro'];
export function setupAuthHook(router: Router) {
  const iam = useIamAuthStore();
  const navStore = useNavStore();
  router.beforeEach(async (to) => {
    navStore.handlerRoute({
      to,
      root: [],
    });
    if (to.name && nav.includes(to.name as string)) {
      if (!iam.loadApp) {
        try {
          await iam.getIamMenu();
        } catch (error) {
          return '/login';
        }
      }

      if (to.name == 'home') {
        const hasMenu = iam.hasMenu('home');

        if (!hasMenu) {
          return true;
        }

        if (!hasMenu.hasPerm) {
          await warning();
          const next = iam.getFirstUrl();

          if (next) {
            // 清楚菜单的缓存
            sessionStorage.removeItem(selectedStoreKey);
            return next;
          } else {
            return '/login';
          }
        }
      } else {
        const el = document.querySelector('#home');
        el?.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant',
        });
        const app = to.params.app as string[];
        if (app.length >= 2) {
          const k = `${app[0]}.${app[1]}`;
          // 转换一下前缀
          const ap = corverProject[k] || k;

          const otherRoute = app?.slice(2);

          const keyPattern =
            ap + (otherRoute.length ? '.' + otherRoute.join('.') : '');

          console.error(keyPattern);

          const hasMenu = iam.hasMenu(keyPattern);
          console.log(hasMenu);

          if (!hasMenu) {
            return true;
          }

          if (!hasMenu.hasPerm) {
            await warning();
            const next = iam.getFirstUrl();
            console.log(next);
            if (next) {
              // 清楚菜单的缓存
              sessionStorage.removeItem(selectedStoreKey);
              return next;
            } else {
              return '/login';
            }
          }
        }
      }
    } else {
      return true;
    }
  });
}

export default router;
